import { FC } from "react";
import { Photo } from "@models/photo";
import { Box } from "@mui/material";
import Picture from "@components/Pictures/Picture";

const Pictures: FC<{
  pictures: Photo[];
  onSelect?: (picture: Photo) => void;
  onCheck?: (picture: Photo) => void;
  selectedPicture?: Photo | null;
  checkedPictures?: Set<Photo>;
  coverPicture?: Photo;
}> = ({ pictures, onSelect, onCheck, selectedPicture, checkedPictures , coverPicture}) => {
  return (
    <Box display="flex" gap="2px" flexWrap="wrap">
      {pictures.map((picture) => (
        <Box key={picture.id} onClick={onSelect && (() => onSelect(picture))}>
          <Picture
            picture={picture}
            selected={selectedPicture === picture}
            onCheck={onCheck && (() => onCheck(picture))}
            checked={!!checkedPictures?.has(picture)}
            coverPicture={coverPicture?.id === picture.id}
          />
        </Box>
      ))}
    </Box>
  );
};

export default Pictures;
